import React, { useCallback } from "react";

import {
	HeaderMenuToggleButton,
	HeaderTop,
	HeaderSpecialLinks,
} from "../components";

import HeaderUserBalance from "../components/HeaderUserBalance";

import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";
import HeaderFailedLoginsCheckButton from "../components/HeaderFailedLoginsCheckButton";
interface SubPageHeaderProps {
	backButton: () => void;
	title: string;
}

export default function SubPageHeader({
	backButton,
	title,
}: SubPageHeaderProps) {
	const {
		userAuthStore: { isLoggedIn },
	} = useRootAppStore();

	const handleBackClick = useCallback(() => {
		if (typeof backButton === "function") {
			backButton();
		}
	}, [backButton]);

	return (
		<header className="l--header l__header">
			<div className="header header--page">
				<div className="header__top">
					<HeaderTop />

					<HeaderSpecialLinks />
				</div>

				<div className="header__main header--page__main">
					<button
						type="button"
						className="header--page__back btn btn--square btn--ghost"
						onClick={handleBackClick}
						aria-label="Go Back"
					>
						<i className="u-icon u-icon--tny u-icon--caret-left u-color--core--snow" />
					</button>

					<div className="header__content">
						<h1 className="header__title">{title}</h1>
					</div>

					<nav className="header__nav">
						{isLoggedIn && (
							<>
								{THEME_SETTINGS.failedLoginReport.isEnabled && (
									<HeaderFailedLoginsCheckButton
										isLabelHidden={true}
									/>
								)}
								<HeaderUserBalance />
							</>
						)}
						<HeaderMenuToggleButton />
					</nav>
				</div>
			</div>
		</header>
	);
}
